export default "__VITE_ASSET__BRxLhRuA__"